import { type StartupModuleSetup } from '../modes/types';

/**
 * Runs mode-owned startup modules sequentially. Each module is a page-lifetime
 * setup function that runs once after bootstrap and before React mount.
 *
 * Unlike recyclable modules, these do not dispose/setup on identity changes —
 * they react to database switches internally via `databaseUILoaded`.
 */
export async function runStartupModules(modules: StartupModuleSetup[]): Promise<void> {
  for (const setup of modules) {
    await setup();
  }
}
